import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner2-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import MainImg from "../assets/Images/mediation2.png";
import TitleImg from "../assets/Images/title.png";
import LineImg from "../assets/Images/line.png";
import ImageTextLayout from "../shared/ImageTextLayout";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./WhyMediationPage.scss";

const WhyMediationPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("why_mediation_page_header")}</h1>
          <p className="banner-subtitle">{t("why_mediation_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_why_mediation_page_link1")}</Link>
        <span>{t("breadcrumbs_why_mediation_page_span")}</span>
        <Link>{t("breadcrumbs_why_mediation_page_link2")}</Link>
      </Breadcrumbs>
      <ImageTextLayout
        image={MainImg}
        imageAlt="Mediation benefits illustration"
        titleIcon={TitleImg}
        title={t("why_mediation_page_h3")}
        className="why-mediation-layout"
        contentClassName="why-mediation-content"
      >
        <ul className="mediation-why-benefits-list">
          {[1, 2, 3, 4, 5, 6, 7].map((item, index) => {
            return (
              <li className="mediation-why-benefit-item" key={index}>
                <div className="benefit-bullet"></div>
                <p style={{ marginTop:'0px' }} className="benefit-text">{t("why_mediation_page_text" + item)}</p>
              </li>
            );
          })}
        </ul>
      </ImageTextLayout>
      <div className="mediation-why-divider">
        <img src={LineImg} alt="Decorative line" className="divider-line" />
      </div>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default WhyMediationPage;
